export default {
  title: {
    en: 'Network error'
  },

  text: {
    en: 'Please check your internet connection.'
  },

  button: {
    en: 'Done'
  }
};
